'use client';

import { useTranslations } from 'next-intl';
import {
  CatModal,
  CatHeading,
  CatIconWarningTriangle
} from 'components/blocks-components';
import { setCookie } from 'utils/cookieUtils';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import { CSP_PENDING_APPROVAL_MODAL } from '../../_constants/constants';
import styles from './pending-approval-modal.module.scss';

export const PendingApprovalModal = ({
  dealerName,
  isPendingApprovalModal
}: {
  dealerName: string;
  isPendingApprovalModal: boolean;
}) => {
  const t = useTranslations();

  const closePendingApprovalModal = () => {
    setCookie(CSP_PENDING_APPROVAL_MODAL, false);
  };

  const heading = replaceTokensInString(
    t('MANUAL_APPROVAL_HEADING', {
      0: dealerName
    })
  );

  const message = replaceTokensInString(
    t('MANUAL_APPROVAL_MESSAGE', {
      0: dealerName
    })
  );

  return (
    <CatModal
      isActive={isPendingApprovalModal}
      size="sm"
      onBlModalClose={closePendingApprovalModal}
    >
      <div
        className={`${styles['pending-approval-modal--wrapper']} gap-3 flex-column d-flex align-items-center text-center`}
      >
        <CatIconWarningTriangle size="xl" color="error" slot="before" />
        <CatHeading
          level="h5"
          className={`${styles['pending-approval-modal--heading']}`}
        >
          <span className="u-color--ExtraDarkGray">{heading}</span>
        </CatHeading>
        <CatHeading variant="body">{message}</CatHeading>
      </div>
    </CatModal>
  );
};
